import { CustomerEnquiryConstant } from "presentation/constant/CustomerEnquiry/CustomerEnquiryConstant";
import { ActiveIndDroOpts } from "presentation/constant/DropDownOptions/Common/ActiveIndDroOpts";
import { useCustomerEnquiryVM } from "presentation/hook/CustomerEnquiry/useCustomerEnquiryVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useCustomerEnquiryTracked } from "presentation/store/CustomerEnquiry/CustomerEnquiryProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useMemo } from "react";
import { FieldType, IFieldValue } from "veronica-ui-component/dist/component/core";

const CustomerEnquirySearchForm = () => {
    const [customerEnquiryState] = useCustomerEnquiryTracked();
    const customerEnquiryVM = useCustomerEnquiryVM();
    const CUSTOMER_ENQUIRY_CONST = CustomerEnquiryConstant;
    const { searchCriteria } = customerEnquiryState;
    const [anainfoState] = useANAInfoTracked();
    const { operatingUnit } = anainfoState;


    const memoCustomrCode = useMemo(() =>
        <div className='flex-row-item' style={{ width: "320px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.customerCodeList?.join(',')}
                fieldValue={searchCriteria?.customerCodeList}
                fieldLabel={CUSTOMER_ENQUIRY_CONST.Table.CUSTOMER_CODE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'customerCodeList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={customerEnquiryState.dynamicOptions.customerCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    customerEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />

        </div>
        , [CUSTOMER_ENQUIRY_CONST.Table.CUSTOMER_CODE, searchCriteria.customerCodeList, customerEnquiryState.dynamicOptions.customerCodeDropdownOptions, customerEnquiryVM])

    const memoCompanyCode = useMemo(() =>
        <div className='flex-row-item' style={{ width: "320px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.companyCodeList?.join(',')}
                fieldValue={searchCriteria?.companyCodeList}
                fieldLabel={CUSTOMER_ENQUIRY_CONST.Table.COMPANY_CODE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'companyCodeList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={customerEnquiryState.dynamicOptions.companyCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    customerEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [CUSTOMER_ENQUIRY_CONST.Table.COMPANY_CODE, searchCriteria.companyCodeList, customerEnquiryState.dynamicOptions.companyCodeDropdownOptions, customerEnquiryVM])


    const memoCustomerType = useMemo(() =>
        <div className='flex-row-item' style={{ width: "320px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.customerType ?? ""}
                fieldValue={searchCriteria?.customerType}
                fieldLabel={CUSTOMER_ENQUIRY_CONST.Table.CUSTOMER_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'customerType'}
                maxLength={60}
                options={customerEnquiryState.dynamicOptions.customerTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    customerEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [CUSTOMER_ENQUIRY_CONST.Table.CUSTOMER_TYPE, searchCriteria.customerType, customerEnquiryState.dynamicOptions.customerTypeDropdownOptions, customerEnquiryVM])


    const memoActiveInd = useMemo(() =>
        <div className='flex-row-item' style={{ width: "320px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.activeInd ?? ""}
                fieldValue={searchCriteria?.activeInd}
                fieldLabel={CUSTOMER_ENQUIRY_CONST.Table.ACTIVE_IND}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'activeInd'}
                maxLength={60}
                options={ActiveIndDroOpts().getDroOptsModel()}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    customerEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [CUSTOMER_ENQUIRY_CONST.Table.ACTIVE_IND, searchCriteria.activeInd, customerEnquiryVM]);

    return <>

        <CriteriaItemContainer>
            {memoCustomrCode}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoCompanyCode}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {memoCustomerType}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {(operatingUnit !== 'SAPT' && operatingUnit !== 'KICT') && memoActiveInd}
        </CriteriaItemContainer>

    </>;
}
export default memo(CustomerEnquirySearchForm);